export json from './json';
export urlEncoded from './urlEncoded';
export formData from './formData';
export text from './text';
export negotiate from './negotiate';
export auth from './auth';
export normalizeUrl from './normalizeUrl';



// WEBPACK FOOTER //
// ./src/Api/middleware/index.js